import {
  RouteReuseStrategy,
  ActivatedRouteSnapshot,
  DetachedRouteHandle
} from '@angular/router';
import { routerState } from './const';

/**
 * Custom Route Reuse Strategy
 *
 * This strategy provides fine-grained control over component reuse:
 * - Reuses menu components across navigation (prevents unnecessary re-renders)
 * - Only recreates router-outlet content when navigating to different routes
 * - Allows reloading components when navigating to the same route
 */
export class CustomRouteReuseStrategy implements RouteReuseStrategy {

  /** Determines if this route (and its subtree) should be detached to be reused later */
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  /**
   * Stores the detached route.
   *
   * Storing a `null` value should erase the previously stored value.
   */
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {}
  /** Determines if this route (and its subtree) should be reattached */
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  /** Retrieves the previously stored route */
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  /**
   * Determines if the route should be reused
   * This controls the core reuse logic
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // For same routes with different query params (refresh), don't reuse
    if (future.routeConfig === curr.routeConfig) {
      // If there's a 'refresh' param that's different, don't reuse
      if (routerState.refresh) {
        return false;
      }

      // If navigating to same route without state.refresh set to true, reuse
      return true;
    }

    // For different routes, allow normal navigation (don't reuse)
    return false;
  }
}
